import { __awaiter, __generator } from "tslib";
import localforage from 'localforage';
import { enableWebOptPerf } from '../featbit/feat-switch';
var CACHE_VERSION = '1.0.0';
var CACHE_PREFIX = 'api_cache_';
var pendingPrefetches = {};
var prefetchedResults = {};
var store = localforage.createInstance({
    name: 'ApiCacheManager',
    storeName: 'api_caches'
});
export var ApiCacheManager = {
    request: function (options) {
        return __awaiter(this, void 0, Promise, function () {
            var key, fetcher, _a, skipCache, _b, storageCache, onUpdate, enableOpt, fullKey, runSilentUpdate, prefetchedResult, cacheData, error_1, data_1, error_2, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        key = options.key, fetcher = options.fetcher, _a = options.skipCache, skipCache = _a === void 0 ? false : _a, _b = options.storageCache, storageCache = _b === void 0 ? true : _b, onUpdate = options.onUpdate;
                        enableOpt = enableWebOptPerf === null || enableWebOptPerf === void 0 ? void 0 : enableWebOptPerf();
                        fullKey = "" + CACHE_PREFIX + key;
                        runSilentUpdate = function () {
                            fetcher()
                                .then(function (freshData) {
                                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(freshData);
                                if (storageCache && freshData !== undefined && freshData !== null) {
                                    ApiCacheManager.setCache(key, freshData).catch(function (err) {
                                        console.warn('[ApiCacheManager] setCache failed during silent update:', err);
                                    });
                                }
                            })
                                .catch(function (err) {
                                console.warn('[ApiCacheManager] Silent update failed:', err);
                            });
                        };
                        if (!skipCache && Object.prototype.hasOwnProperty.call(prefetchedResults, fullKey)) {
                            prefetchedResult = prefetchedResults[fullKey];
                            delete prefetchedResults[fullKey];
                            runSilentUpdate();
                            return [2, prefetchedResult];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        if (!(enableOpt && storageCache && !skipCache)) return [3, 3];
                        return [4, store.getItem(fullKey)];
                    case 2:
                        cacheData = _c.sent();
                        if (cacheData && cacheData.version === CACHE_VERSION) {
                            runSilentUpdate();
                            return [2, cacheData.data];
                        }
                        _c.label = 3;
                    case 3: return [3, 5];
                    case 4:
                        error_1 = _c.sent();
                        console.warn('[ApiCacheManager] IndexedDB read failed:', error_1);
                        return [3, 5];
                    case 5:
                        if (!(!skipCache && pendingPrefetches[fullKey])) return [3, 9];
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        return [4, pendingPrefetches[fullKey]];
                    case 7:
                        data_1 = _c.sent();
                        delete prefetchedResults[fullKey];
                        if (data_1 !== undefined && data_1 !== null) {
                            runSilentUpdate();
                            return [2, data_1];
                        }
                        return [3, 9];
                    case 8:
                        error_2 = _c.sent();
                        console.warn('[ApiCacheManager] Pending prefetch failed, fallback to fetcher:', error_2);
                        return [3, 9];
                    case 9: return [4, fetcher()];
                    case 10:
                        data = _c.sent();
                        if (!(enableOpt && storageCache && data !== undefined && data !== null)) return [3, 12];
                        return [4, ApiCacheManager.setCache(key, data)];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12: return [2, data];
                }
            });
        });
    },
    prefill: function (key, promise, options) {
        if (options === void 0) { options = {}; }
        var fullKey = "" + CACHE_PREFIX + key;
        var _a = options.storageCache, storageCache = _a === void 0 ? true : _a;
        if (pendingPrefetches[fullKey]) {
            return pendingPrefetches[fullKey];
        }
        var trackedPromise = promise.then(function (data) {
            delete pendingPrefetches[fullKey];
            if (data !== undefined && data !== null) {
                prefetchedResults[fullKey] = data;
                if (storageCache && (enableWebOptPerf === null || enableWebOptPerf === void 0 ? void 0 : enableWebOptPerf())) {
                    return ApiCacheManager.setCache(key, data).then(function () { return data; });
                }
            }
            return data;
        }, function (error) {
            delete pendingPrefetches[fullKey];
            throw error;
        });
        pendingPrefetches[fullKey] = trackedPromise;
        return trackedPromise;
    },
    setCache: function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            var fullKey, newCacheData, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (data === undefined || data === null) {
                            console.warn('[ApiCacheManager] Invalid data to set cache:', data);
                            return [2];
                        }
                        fullKey = "" + CACHE_PREFIX + key;
                        newCacheData = {
                            data: data,
                            timestamp: Date.now(),
                            version: CACHE_VERSION
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, store.setItem(fullKey, newCacheData)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.warn('[ApiCacheManager] setCache failed:', error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    },
    clear: function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, store.removeItem("" + CACHE_PREFIX + key)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.warn('[ApiCacheManager] clear failed:', error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    },
    clearAll: function () {
        return __awaiter(this, void 0, void 0, function () {
            var keys, cacheKeys, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, store.keys()];
                    case 1:
                        keys = _a.sent();
                        cacheKeys = keys.filter(function (k) { return k.startsWith(CACHE_PREFIX); });
                        return [4, Promise.all(cacheKeys.map(function (k) { return store.removeItem(k); }))];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.warn('[ApiCacheManager] clearAll failed:', error_5);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    }
};
